import {Navigation, Zoom} from "swiper/modules";
import Swiper from "swiper";

// noinspection JSUnusedLocalSymbols
/**
 * A wrapper for Swiper.js
 *
 * @param {HTMLElement} swiperContainer
 * @param {import('swiper/types/swiper-options').SwiperOptions} swiperSettings
 * @param {ModalV3} parentModal
 */
function initSwiper(swiperContainer, swiperSettings = {}, parentModal = null) {
	// noinspection UnnecessaryLocalVariableJS
	const swiperInstance = new Swiper(
		swiperContainer,
		{
			loop: true,
			modules: [Navigation, Zoom],
			zoom: true,
			navigation: {
				nextEl: swiperContainer.querySelector(".swiper-button-next"),
				prevEl: swiperContainer.querySelector(".swiper-button-prev"),
			},
			...swiperSettings
		}
	)

	return swiperInstance;
}

export {initSwiper};
